import Service from './Service';

export default class ExternalSubcategoryMapService extends Service{
    constructor() {
        super();
        this.baseURL = 'externalSubcategoryMap';
    }

}